export const SALES_MODE: { [key: string]: string } = {
  PICK_UP_IN_STORE: 'Retire na loja',
  SHIPPING_FROM_STORE: 'Entrega pela loja',
};
